export default __webpack_public_path__ + "static/media/File.7f4d3612.png";